import { isNonProduction } from "../../utils";
import { Button } from "web-design-system";
import ErrorIllustration from "../../assets/images/error.webp";

export function SomethingWentWrong({
  error,
  onReset,
}: {
  error: Error;
  onReset?: () => void;
}) {
  return (
    <div className="size-full rounded-lg bg-background">
      <div className="flex flex-col size-full items-center justify-center">
        <img src={ErrorIllustration} alt="Error" />
        <span className="mt-6 font-semibold text-lg">
          Something went wrong.
        </span>
        <p className="text-center mt-2 text-muted-foreground text-sm">
          We are already on it. Feel free to reach out to us if refreshing
          doesn&apos;t help
        </p>
        {isNonProduction() && (
          <span className="text-muted-foreground text-xs mt-2">
            {error.message}
          </span>
        )}
        <div className="flex gap-2 mt-4">
          {onReset && (
            <Button onClick={onReset} size="lg" variant="outline">
              Try Again
            </Button>
          )}
          <Button onClick={() => window.location.reload()} size="lg">
            Reload Page
          </Button>
        </div>
      </div>
    </div>
  );
}
